import axios from "axios";

// Variable
const hkoWeatherDataLink = process.env.REACT_APP_HKO_API_LINK;

const api = axios.create({
  baseURL: `${hkoWeatherDataLink}`,
  timeout: 10000,
});

function getRainfallInformation() {
  return api.get(`/hourlyRainfall.php?lang=en`);
}

function getWeatherOutlook() {
  return api.get(`/weather.php?dataType=fnd&lang=tc`);
}

function getWeatherForecast() {
  return api.get(`/weather.php?dataType=flw&lang=tc`);
}

function getWeatherWarning() {
  return api.get(`/weather.php?dataType=warnsum&lang=tc`);
}

function getFeltTermorMessage() {
  return api.get(`/earthquake.php?dataType=feltearthquake&lang=tc`);
}

function getWeatherAlert() {
  return api.get(`/weather.php?dataType=swt&lang=tc`);
}

export {
  getRainfallInformation,
  getWeatherOutlook,
  getWeatherForecast,
  getWeatherWarning,
  getFeltTermorMessage,
  getWeatherAlert,
};
